import { render, staticRenderFns } from "./WizardButtonGroup.vue?vue&type=template&id=7c04a6ec"
import script from "./WizardButtonGroup.vue?vue&type=script&lang=ts"
export * from "./WizardButtonGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports